// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.layout-section {
  padding: 1rem;
}

.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone .textLink {
  color: #1F2937 !important;
}
.dropzone .textLink u {
  text-decoration: underline;
  margin-left: 4px;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.table-wrapper {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.table-header .user-label img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.table-header .user-label .layout-header-icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(212deg) brightness(97%) contrast(92%) !important;
  width: 24px;
  height: 24px;
}

:host ::ng-deep p-button.sub-layout-add-button {
  opacity: 1 !important;
}
:host ::ng-deep p-button.sub-layout-add-button,
:host ::ng-deep p-button.sub-layout-add-button * {
  opacity: 1 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]),
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]),
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled),
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled) {
  opacity: 1 !important;
  cursor: pointer !important;
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]):hover,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]):hover,
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled):hover,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled):hover {
  opacity: 1 !important;
  background: #f3f4f6 !important;
  color: #1E38A9 !important;
  border-color: #1E38A9 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]):active, :host ::ng-deep p-button.sub-layout-add-button button.p-button:not(:disabled):not([disabled]):focus,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]):active,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(:disabled):not([disabled]):focus,
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled):active,
:host ::ng-deep p-button.sub-layout-add-button button.p-button:not(.p-disabled):focus,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled):active,
:host ::ng-deep p-button.sub-layout-add-button .p-button:not(.p-disabled):focus {
  opacity: 1 !important;
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
}
:host ::ng-deep p-button.sub-layout-add-button button.p-button:disabled,
:host ::ng-deep p-button.sub-layout-add-button .p-button:disabled,
:host ::ng-deep p-button.sub-layout-add-button button.p-button[disabled],
:host ::ng-deep p-button.sub-layout-add-button .p-button[disabled],
:host ::ng-deep p-button.sub-layout-add-button button.p-button.p-disabled,
:host ::ng-deep p-button.sub-layout-add-button .p-button.p-disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}
:host ::ng-deep .gc-form-section .gc-form-section-heading.collapsed {
  border-bottom: none !important;
}
:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1E38A9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  margin-bottom: 0;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form .grid.p-fluid .col-12 {
  margin-bottom: 0.5rem;
}
:host ::ng-deep .gc-form-section .sidebar-form .grid.p-fluid .col-12:last-child {
  margin-bottom: 0;
}
:host ::ng-deep .gc-form-section .sidebar-form .nested-form-group {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #dee2e6;
}
:host ::ng-deep .gc-form-section .sidebar-form .nested-form-group h4, :host ::ng-deep .gc-form-section .sidebar-form .nested-form-group h5 {
  margin: 0;
  color: #1E38A9;
  font-weight: 600;
  font-size: 18px;
}
:host ::ng-deep .gc-form-section .sidebar-form .nested-form-group .grid.p-fluid {
  margin-bottom: 0;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section {
  margin-bottom: 1rem;
  border: 1px solid #e5e7eb;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section .gc-form-section-heading {
  padding: 12px 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section .gc-form-section-heading h4 {
  font-size: 16px;
}
:host ::ng-deep .gc-form-section .sidebar-form .gc-form-section .gc-form-section .sidebar-form {
  padding: 16px;
}
:host ::ng-deep .p-sidebar-right {
  width: 704px !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger,
:host ::ng-deep .p-sidebar .p-button-danger,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger,
:host ::ng-deep .p-sidebar .p-button.p-button-danger,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  color: #dc3545 !important;
  box-shadow: none !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button.p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm:hover {
  background: rgba(220, 53, 69, 0.1) !important;
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #c82333 !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger:focus, :host ::ng-deep .p-sidebar button.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger:focus,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button.p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button.p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm:active {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .p-sidebar button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button.p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar .p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar button.p-button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar .p-button.p-button-text.p-button-danger.p-button-sm .pi {
  color: #dc3545 !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  color: #dc3545 !important;
  box-shadow: none !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm:hover,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger:hover,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:hover {
  background: rgba(220, 53, 69, 0.1) !important;
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #c82333 !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger:focus, :host ::ng-deep .p-sidebar p-button button.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm:active,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger:active,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:focus,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger:active {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep .p-sidebar p-button button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger.p-button-sm .pi,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button button.p-button.p-button-text.p-button-danger .pi,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .p-button-icon,
:host ::ng-deep .p-sidebar p-button .p-button.p-button-text.p-button-danger .pi {
  color: #dc3545 !important;
}
:host ::ng-deep .p-checkbox .p-checkbox-box {
  border-color: #1E38A9;
}
:host ::ng-deep .p-checkbox .p-checkbox-box.p-highlight {
  background-color: #2d388b;
  border-color: #2d388b !important;
}
:host ::ng-deep .p-dropdown {
  height: 54px;
}
:host ::ng-deep .p-dropdown .p-dropdown-label {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 12px 16px;
  line-height: 30px;
}
:host ::ng-deep .p-dropdown .p-dropdown-trigger {
  display: flex;
  align-items: center;
}
:host ::ng-deep .p-dropdown.p-dropdown-empty .p-dropdown-label {
  display: flex;
  align-items: center;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button {
  width: auto !important;
  min-width: 80px;
  display: inline-block;
  opacity: 1 !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button {
  width: auto !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled),
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled),
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled) {
  opacity: 1 !important;
  cursor: pointer !important;
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
  transition: all 0.2s ease !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled):hover,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled):hover,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled):hover {
  background: #f3f4f6 !important;
  color: #1E38A9 !important;
  border-color: #1E38A9 !important;
  opacity: 1 !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled):active, :host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:not([disabled]):not(.p-disabled):focus,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled):active,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:not([disabled]):not(.p-disabled):focus,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled):active,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:not([disabled]):not(.p-disabled):focus {
  background-color: #fff !important;
  color: #1E38A9 !important;
  border: 1px solid #1E38A9 !important;
  opacity: 1 !important;
  box-shadow: none !important;
  outline: none !important;
}
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button[disabled], :host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-disabled, :host ::ng-deep ::ng-deep p-button.sub-layout-add-button button:disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button[disabled],
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button.p-disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button .p-button:disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button[disabled],
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button.p-disabled,
:host ::ng-deep ::ng-deep p-button.sub-layout-add-button button.p-button:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}
:host ::ng-deep .p-sidebar *[class*=p-button-danger], :host ::ng-deep .p-sidebar *.p-button-danger {
  background: transparent !important;
  background-color: transparent !important;
}
:host ::ng-deep .p-sidebar p-button *[class*=p-button-danger], :host ::ng-deep .p-sidebar p-button *.p-button-danger {
  background: transparent !important;
  background-color: transparent !important;
}

.gc-form-section {
  margin-bottom: 2rem;
}

.sidebar-form {
  padding: 0.5rem;
}

.red {
  color: #FF3C3C;
  margin-left: 2px;
}

.popup-wrapper {
  position: relative;
}

.sidebar-interaction-blocker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1000;
  cursor: not-allowed;
}

.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  opacity: 0.8;
}
.cursor-pointer.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.gc-form-heading {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1E38A9;
}

.gc-form-section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gc-form-section-heading.cursor-pointer {
  -webkit-user-select: none;
          user-select: none;
}
.gc-form-section-heading.cursor-pointer h3, .gc-form-section-heading.cursor-pointer h4, .gc-form-section-heading.cursor-pointer h5 {
  -webkit-user-select: none;
          user-select: none;
}
.gc-form-section-heading .pi {
  font-size: 0.875rem;
  transition: transform 0.2s;
}
.gc-form-section-heading.collapsed {
  border-bottom: none !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
